import {
  FarmLocationApiData,
  FarmLocationResponse,
  FarmLocationTableData,
  FarmLocationTableRow,
  Parameters,
} from '@app/models/farm_locations/FarmLocationresponse';
import { post, get, remove } from './http.api';
import { FarmLocationRequest } from '@app/models/farm_locations/FarmLocationRequest';

export const getFarmLocationTableData = async (parameters: Parameters): Promise<FarmLocationTableData> => {
  try {
    const { data, status } = await get<any>('pr_locations', { params: parameters }, true);
    console.log(`Status: ${status}`, `Data:`, data);

    const apiData = data.pr_locations || data;

    const locations: FarmLocationTableRow[] = apiData.data.map((locationData: any) => ({
      id: locationData.id,
      code: locationData.code,
      name: locationData.name,
      status: locationData.status,
    }));

    return {
      data: locations,
      pagination: {
        current: data.current_page,
        pageSize: data.per_page,
        total: data.total,
      },
      status_options: data.status_options || [],
    };
  } catch (error: any) {
    console.error('Error fetching Locations:', error);
    throw error;
  }
};

export const getAllFarmLocations = async (): Promise<FarmLocationResponse> => {
  try {
    const { data, status } = await get<FarmLocationResponse>(`pr_locations`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getLocactionById = async (id: number): Promise<FarmLocationResponse> => {
  try {
    const { data, status } = await get<FarmLocationResponse>(`pr_locations/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const storeFarmLocation = async (locationData: FarmLocationRequest) => {
  try {
    const response = await post<any>('pr_locations/create', locationData, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const createFarmLocation = async (): Promise<FarmLocationApiData> => {
  try {
    const { data, status } = await get<FarmLocationApiData>(`pr_locations/create`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const showFarmLocation = async (id: number) => {
  try {
    const { data, status } = await get<FarmLocationApiData>(`pr_locations/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const editFarmLocation = async (id: number) => {
  try {
    const { data, status } = await get<FarmLocationApiData>(`pr_locations/${id}/edit`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const updateFarmLocation = async (id: number, Updatelocation: FarmLocationRequest) => {
  try {
    const { data, status } = await post<FarmLocationRequest>(
      `pr_locations/${id}/edit`,
      Updatelocation,
      undefined,
      true,
    );
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const activateFarmLocation = async (id: number) => {
  try {
    const { data, status } = await post<FarmLocationRequest>(`pr_locations/${id}/activate`, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const RemoveFarmLocation = async (id: number) => {
  try {
    const response = await remove<any>(`pr_locations/${id}`, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};
